import React from 'react';
import Stats from './Stats';
import BeneficiaryTable from './BeneficiaryTable';
import AllocationStat from './AllocationStat';
import ActivitySummary from './ActivitySummary';

export default function CompleteDashboard() {
  return (
    <div>
      <Stats />
      <div className="mt-3">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 w-full lg:col-span-8">
            <BeneficiaryTable />
          </div>
          <div className="col-span-12 w-full lg:col-span-4">
            <div className="w-full rounded-lg bg-white">
              <p className="p-5 text-sm font-semibold text-[#353535]">
                Asset Allotment
              </p>
              <div className="flex items-center justify-center">
                <AllocationStat />
              </div>
              <div className="px-5 pb-20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 w-full lg:col-span-8">
            <ActivitySummary />
          </div>
          <div className="col-span-12 w-full lg:col-span-4">
            <div className="w-full rounded-lg bg-white">
              <p className="px-5 pt-3 text-sm font-semibold text-[#353535]">
                How To...
              </p>
              <div className="flex flex-col">
                <iframe
                  className="h-56 p-4"
                  src="https://www.youtube.com/embed/JhdK5LahhDU"
                  allow="autoplay; encrypted-media"
                ></iframe>
              </div>
              <div className="px-5 pb-5">
                <p className="text-sm font-semibold text-[#FF6606]">
                  Will Writing Explained
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
